"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.t = void 0;
/* eslint-disable */
const vue_1 = __importDefault(require("vue"));
const vue_i18n_1 = __importDefault(require("vue-i18n"));
const locale_1 = __importDefault(require("element-ui/lib/locale"));
const en_1 = __importDefault(require("./en"));
const cn_1 = __importDefault(require("./cn"));
const vi_1 = __importDefault(require("./vi"));
vue_1.default.use(vue_i18n_1.default);
// 注册i8n实例并引入语言文件
const i18n = new vue_i18n_1.default({
    locale: localStorage.getItem('language') || 'en',
    messages: {
        'en': en_1.default,
        'cn': cn_1.default,
        'vi': vi_1.default
    },
    silentTranslationWarn: true // 控制台不提示
});
locale_1.default.i18n((key, value) => i18n.t(key, value));
exports.t = i18n.t;
exports.default = i18n; // 将i18n暴露出去，在main.js中引入挂载
